import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import twemoji from "twemoji";

import PortalVue from 'portal-vue';
Vue.use(PortalVue);

Vue.config.productionTip = false;

Vue.directive("parse-emojis", {
  inserted(el) {
    twemoji.parse(el, {
      base: 'https://cdn.jsdelivr.net/gh/twitter/twemoji@latest/assets/',
      folder: 'joypixels/png/64',
      ext: '.png'
    });
  },
  componentUpdated(el) {
    twemoji.parse(el, {
      base: 'https://cdn.jsdelivr.net/gh/twitter/twemoji@latest/assets/',
      folder: 'joypixels/png/64',
      ext: '.png'
    });
  }
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')